"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.broadcastMessageRecipientGroup = void 0;
const enums_1 = require("@bemlo/enums");
exports.broadcastMessageRecipientGroup = {
    [enums_1.BroadcastMessageRecipientGroup.INTERNAL]: 'Colleagues',
    [enums_1.BroadcastMessageRecipientGroup.SUPPLIERS]: 'Suppliers',
    [enums_1.BroadcastMessageRecipientGroup.EMPLOYEES]: 'Employees',
};
